import { Controller, get } from "react-hook-form";
import { SelectField } from "../../ui";
import { PixKeyTypeEnum } from "../../../../pages/enum";

interface SelectPixKeyTypeProps {
    name: string;
    methods: any;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export function SelectPixKeyType({
    name,
    methods,
    disabled = false,
    required = false,
    label = "Tipo de Chave Pix",
}: SelectPixKeyTypeProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field, formState: { errors } }) => {
                const error = get(errors, name);
                return (
                    <SelectField
                        label={label}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        required={required}
                        disabled={disabled}
                        error={!!error}
                        helperText={error?.message as string}
                    >
                        <option value="">Selecione...</option>
                        <option value={PixKeyTypeEnum.CPF}>CPF</option>
                        <option value={PixKeyTypeEnum.CNPJ}>CNPJ</option>
                        <option value={PixKeyTypeEnum.EMAIL}>E-mail</option>
                        <option value={PixKeyTypeEnum.PHONE}>Telefone</option>
                        <option value={PixKeyTypeEnum.RANDOM}>Aleatória</option>
                    </SelectField>
                );
            }}
        />
    );
}
